import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { CarOutlined, TagFilled } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { getLabelStore } from 'core/modules/labels/label.store';
import { TASK_STATE_TRANSITIONS, TaskState } from 'core/modules/tasks/task.interface';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LabelSelect } from 'src/components/Form/LabelsSelect';
import { TaskStateSelect } from 'src/components/Form/TaskStateSelect';
import { CreateRouteModal } from 'src/components/Routes/CreateRouteModal';
import { SettingsEntityDeleteModal } from 'src/components/Settings/SettingsEntityDeleteModal';
import { TasksChangeStateModal } from 'src/components/Tasks/ChangeStateModal';
import { TaskReferenceView } from 'src/components/Tasks/Reference';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TasksTableActions = function TasksTableActions(_ref) {
  var selectedItems = _ref.selectedItems;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getLabelStore = getLabelStore(),
      getLabelById = _getLabelStore.getLabelById;

  var _getTaskStore = getTaskStore(),
      deleteTask = _getTaskStore.deleteTask,
      updateTask = _getTaskStore.updateTask;

  var _useState = useState(false),
      showDeleteModal = _useState[0],
      setShowDeleteModal = _useState[1];

  var _useState2 = useState([]),
      selectedLabels = _useState2[0],
      setSelectedLabels = _useState2[1];

  var _useState3 = useState(false),
      isLoadingLabels = _useState3[0],
      setLoadingLabels = _useState3[1];

  var _useState4 = useState(),
      currentState = _useState4[0],
      setCurrentState = _useState4[1];

  var _useState5 = useState(),
      selectedState = _useState5[0],
      setSelectedState = _useState5[1];

  var _useState6 = useState([]),
      createRouteTaskIds = _useState6[0],
      setCreateRouteTaskIds = _useState6[1];

  var availableStates = useMemo(function () {
    var statesMap = {};

    var _iterator = _createForOfIteratorHelper(selectedItems),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _TASK_STATE_TRANSITIO;

        var task = _step.value;

        var _iterator2 = _createForOfIteratorHelper((_TASK_STATE_TRANSITIO = TASK_STATE_TRANSITIONS[task.content.type][task.state]) !== null && _TASK_STATE_TRANSITIO !== void 0 ? _TASK_STATE_TRANSITIO : []),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var state = _step2.value;
            statesMap[state] = true;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return Object.values(TaskState).filter(function (state) {
      return statesMap[state];
    });
  }, [selectedItems]);
  var entities = useMemo(function () {
    return selectedItems.map(function (item) {
      return {
        id: item.id,
        name: /*#__PURE__*/_jsx(TaskReferenceView, {
          task: item
        })
      };
    });
  }, [selectedItems]);

  function changeLabels() {
    return _changeLabels.apply(this, arguments);
  }

  function _changeLabels() {
    _changeLabels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoadingLabels(true);
              _context2.prev = 1;
              _context2.next = 4;
              return Promise.all(selectedItems.map(function (task) {
                return updateTask(task.id, _objectSpread(_objectSpread({}, task), {}, {
                  labelIds: selectedLabels
                }));
              }));

            case 4:
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);

            case 9:
              setLoadingLabels(false);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 6]]);
    }));
    return _changeLabels.apply(this, arguments);
  }

  var onCreateRouteClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setCreateRouteTaskIds(selectedItems.map(function (it) {
                return it.id;
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onCreateRouteClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(Container, {
    children: [selectedItems.length > 1 && /*#__PURE__*/_jsxs(Space, {
      children: [/*#__PURE__*/_jsx(Button, {
        type: "primary",
        danger: true,
        onClick: function onClick() {
          return setShowDeleteModal(true);
        },
        children: t('tasks.multiple.delete.title')
      }), /*#__PURE__*/_jsx(LabelSelect, {
        placeholder: t('tasks.multiple.labels.title'),
        isMultiple: true,
        className: "select-button",
        value: selectedLabels,
        tagRender: function tagRender(item) {
          var _getLabelById;

          return /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx("span", {
              className: "icon",
              style: {
                margin: '0 5px'
              },
              children: /*#__PURE__*/_jsx(TagFilled, {
                style: {
                  color: (_getLabelById = getLabelById(item.value)) === null || _getLabelById === void 0 ? void 0 : _getLabelById.color
                }
              })
            })
          });
        },
        onDropdownVisibleChange: function onDropdownVisibleChange() {
          return setSelectedLabels([]);
        },
        onChange: setSelectedLabels,
        dropdownRender: function dropdownRender(menu) {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [menu, /*#__PURE__*/_jsx("div", {
              className: "change-labels-footer",
              style: {
                margin: '10px 10px'
              },
              children: /*#__PURE__*/_jsx(Button, {
                type: "primary",
                loading: isLoadingLabels,
                block: true,
                onClick: function onClick() {
                  return changeLabels();
                },
                children: t('tasks.multiple.labels.cta')
              })
            })]
          });
        }
      }), /*#__PURE__*/_jsx(TaskStateSelect, {
        isMultiple: true,
        value: currentState ? [currentState] : undefined,
        states: availableStates,
        onSelect: function onSelect(newValue) {
          setCurrentState(newValue);
          setSelectedState(newValue);
        },
        placeholder: t('tasks.multiple.state.label'),
        className: "select-button change-tasks",
        tagRender: function tagRender(item) {
          return /*#__PURE__*/_jsx("span", {
            style: {
              marginLeft: '10px'
            },
            children: item.label
          });
        }
      }), /*#__PURE__*/_jsx(Button, {
        icon: /*#__PURE__*/_jsx(CarOutlined, {}),
        type: "primary",
        onClick: onCreateRouteClick,
        children: "Crear ruta"
      })]
    }), /*#__PURE__*/_jsx(SettingsEntityDeleteModal, {
      isVisible: showDeleteModal,
      deleteItem: deleteTask,
      entity: "task",
      items: entities,
      onCancel: function onCancel() {
        return setShowDeleteModal(false);
      }
    }), /*#__PURE__*/_jsx(TasksChangeStateModal, {
      isVisible: !!selectedState,
      tasks: selectedItems,
      newState: selectedState,
      onCancel: function onCancel() {
        setSelectedState(undefined);
        setCurrentState(undefined);
      }
    }), /*#__PURE__*/_jsx(CreateRouteModal, {
      isOpen: createRouteTaskIds.length > 0,
      initialTaskIds: createRouteTaskIds,
      onClose: function onClose() {
        return setCreateRouteTaskIds([]);
      }
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "TableActions__Container",
  componentId: "sc-optrq-0"
})([".select-button{min-width:200px;.change-labels-footer{padding:10px;}.ant-select-selection-placeholder{color:black;}}"]);